<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 부가정보 : 산업용 로봇 정보-->
    <write-grid-container
      title="산업용 로봇 정보"
      v-model="form.subInfo"
      :options="gridContainerOptions"
    >
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input" v-if="dataType === 'date'">{{form.subInfo[value]}}</div>
          <div class="print-input" v-else>{{form.subInfo[value]}}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full"
                         v-model="form.subInfo[value]" />
          <number-input v-else-if="dataType === 'number'"
                        v-model="form.subInfo[value]"/>
          <ml-input v-else
                    class="w-full"
                    v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import {required} from "vuelidate/lib/validators";
import NumberInput from "@/components/NumberInput.vue";

export default {
  components: {
    NumberInput,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      gridContainerOptions: {
        dataTypes: ['string', 'string', 'string', 'date', 'string', 'date', 'date', 'string'],
        labels: ['구분', '설비명', '자체 관리번호', '설치일', '합격번호', '최근 안전검사일', '차기 안전검사일', '제작업체'],
        values: ['구분', '설비명', '자체관리번호', '설치일', '합격번호', '최근안전검사일', '차기안전검사일', '제작업체'],
      },
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = '';
      return acc;
    }, {})

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
